


import { useEffect, useState } from "react"
import styled from "styled-components"
import { getCityToCityIndex, getNakliyeSeasonIndex, getTopluNakliyeCityToCityIndexExcel, updateCityToCityIndex, updateNakliyeSeasonIndex } from "../../features/nakliyeIndex/nakliyeIndexSlice"
import { useDispatch, useSelector } from "react-redux"
import Btn from "../shared/button/Btn"
import InputSelect from "../shared/input/new/InputSelect"
import locationCityOptionsForIndex from "../../utils/locationData/locationCityOptionsForIndex"
import SmallSpinner from "../shared/spinners/SmallSpinner"
import InputSelectCityMultiple from "../shared/input/new/InputSelectCityMulti"
import { BiSolidSortAlt, BiSolidUpArrow, BiSolidDownArrow } from "react-icons/bi";
import { showModal } from "../../features/modal/modalSlice"

const Container = styled.div`
    display: flex;
    flex-direction: column;

    .top-container{ 
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 30px;

        .filter-container{
            display: flex;
            gap: 20px;
        }

        .btn-container{
            display: flex;
            gap: 20px;

        }

    }
    

    .table{
        width: 550px;
        border-collapse: collapse;

        thead{
            width: 100%;
            background-color: var(--color-main);

            tr{

                th{
                    color: #fff;
                    padding: 10px 15px;
                    border-right: 1px solid #fff;
                    font-size: var(--font-size-sm);
                    font-weight: var(--font-weight-lg);
                    text-align: start;
                    width: 200px;

                    &:first-child{
                        border-left: 1px solid var(--color-main);
                    }

                    &:last-child{
                        text-align: center;
                        border-right: 1px solid var(--color-main);
                        width: 150px;
                    }

                    .title-text{
                        width: 100%;
                        display: flex;
                        justify-content: center;
                        align-items: center;

                        .sort-icon{
                            font-size: 1rem;
                            cursor: pointer;
                        }
                    }

                }
            }
        }

        tbody{

            tr{
                td{

                    border: 1px solid ${({theme}) => theme.mainTextColor};
                    text-align: start;
                    font-size: var(--font-size-sm);
                    font-weight: var(--font-weight-lg);
                    padding: 10px 15px;

                    &:last-child{
                        text-align: center;
                    }

                    input{
                        width: 100%;
                        text-align: center;

                    }
                }
            }

        }
    }

    .bottom-container{
        width: 550px;
        margin-top: 30px;
        display: flex;
        justify-content: center;
    }
    
`



const initialTitles = [
    {
        id: 1,
        text: "Nereden",
        sortState: 0
    },
    {
        id: 2,
        text: "Nereye",
        sortState: 0
    },
    {
        id: 3,
        text: "İndeks",
        sortState: 0
    },
    {
        id: 4,
        text: "Km",
        sortState: 0
    },
]


const NakliyeCityToCityIndex = () => {

    const dispatch = useDispatch()

    const {cityToCityIndex, isLoadingGetTopluNakliyeCityToCityIndexExcel} = useSelector(state => state.nakliyeIndex)

    const [updatedDataList, setUpdatedDataList] = useState([])

    const [selectedCityList, setSelectedCityList] = useState([])


    const [titles, setTitles] = useState(initialTitles)
    //! bu filtreleme ile ekrana döndüren
    const [cityListOption, setCityListOption] = useState([])

    const [selectedCity, setSelectedCity] = useState({
        id:35,
        text: "İzmir"
    })

    useEffect(() => {
        setUpdatedDataList(cityToCityIndex.toCityIndex)
        setCityListOption(cityToCityIndex.toCityIndex)
    },[cityToCityIndex])

    useEffect(() => {
        dispatch(getCityToCityIndex(selectedCity.id))
    },[selectedCity.id])

    useEffect(() => {
        const idList = selectedCityList.map(item => item.cityId)
        if(idList.length > 0){
            setCityListOption(updatedDataList.filter(item => idList.includes(item.cityId)))
        }
        else{
            setCityListOption(updatedDataList)
        }

    },[selectedCityList.length])

    // // console.log(updatedDataList);

    const handleSortChange = ({id, sortState}) => {

        const titleList = titles.map((item) => {
            if(item.id === id){
                return {...item, sortState}
            }
            else{
                return { ...item, sortState: 0}
            }
        })

        if(id === 2){
            if(sortState === 0){
                setCityListOption([...cityListOption].sort((a, b) => a.city.localeCompare(b.city, 'tr')))
            }
            else if(sortState === 1){
                setCityListOption([...cityListOption].sort((a, b) => b.city.localeCompare(a.city, 'tr')))
            }
            else{
                setCityListOption([...cityListOption].sort((a, b) => a.city.localeCompare(b.city, 'tr')))
            }
        }

        if(id === 3){
            if(sortState === 0){
                setCityListOption([...cityListOption].sort((a, b) => a.city.localeCompare(b.city, 'tr')))
            }
            else if(sortState === 1){
                setCityListOption([...cityListOption].sort((a, b) => a.index - b.index))
            }
            else{
                setCityListOption([...cityListOption].sort((a, b) => b.index - a.index))
            }
        }

        if(id === 4){
            if(sortState === 0){
                setCityListOption([...cityListOption].sort((a, b) => a.city.localeCompare(b.city, 'tr')))
            }
            else if(sortState === 1){
                setCityListOption([...cityListOption].sort((a, b) => a.km - b.km))
            }
            else{
                setCityListOption([...cityListOption].sort((a, b) => b.km - a.km))
            }
        }

        setTitles(titleList)
    }

    const handleChange = ({key, value, id}) => {
        const list = updatedDataList.map((item) => {
            if(item.id === id){
                return {...item, [key]: value === "" ? value : parseInt(value.replace(/[^0-9]/g, ''))}
            }
            else{
                return item
            }
        })
        setUpdatedDataList(list)
        setCityListOption(list)
    }

    const handleSubmit = () => {

        const filtered = updatedDataList.filter((item, i) => {
            const jsonString1 = JSON.stringify(item);
            const jsonString2 = JSON.stringify(cityToCityIndex.toCityIndex[i]);
            return jsonString1 !== jsonString2
        })    

        dispatch(updateCityToCityIndex(filtered.map((item) => {
            return {
                index: item.index,
                km: item.km,
                city: item.city,
                neredenCityId: cityToCityIndex.cityId,
                nereyeCityId: item.cityId,
                id: item.id
            }
        })))
    }



  return (
    <Container>
        <div className="top-container">
            <div className="filter-container">
                <InputSelect data={selectedCity.text} setData={setSelectedCity} labelText={"İl Seçiniz"} inputWidth={"180px"} initialOptions={locationCityOptionsForIndex} name={"nakliyeIllerarasiIndexCity"}/>
                {/* <InputSelect data={selectedCity.text} setData={setSelectedCity} labelText={"İlçe Filtreleyin"} inputWidth={"190px"} initialOptions={locationCityOptionsForIndex} name={"nakliyeIllerarasiIndexCity"}/> */}
                <InputSelectCityMultiple data={selectedCityList} setData={setSelectedCityList} labelText={"İl Filtreleyin"} inputWidth={"200px"} filterKey={"city"} initialOptions={updatedDataList} name={"nakliyeIllerarasiIndexNereden"}/>
            </div>
            <div className="btn-container">
                <Btn borderColor="#E85446" color="#E85446" width={"200px"} handleClick={() => dispatch(showModal("nakliyeIndexCityToCityAddExcel"))}>Excelden Toplu Kaydet</Btn>
                <Btn borderColor="#E85446" color="#E85446" width={"200px"} handleClick={() => dispatch(getTopluNakliyeCityToCityIndexExcel())} isDisabled={isLoadingGetTopluNakliyeCityToCityIndexExcel} cursor={isLoadingGetTopluNakliyeCityToCityIndexExcel && "not-allowed"}>{isLoadingGetTopluNakliyeCityToCityIndexExcel ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"}/> : "Excel Çıktı Al"}</Btn>
            </div>
        </div>
        <table className="table">
            <thead>
                <tr>
                    {
                        titles.map((item, i) => (
                            <th key={item.id}>
                                <div className={"title-text"}>
                                    {item.text}
                                    {
                                        (item.sortState === 0 && i !== 0) &&
                                        <BiSolidSortAlt onClick={() => handleSortChange({id: item.id, sortState: item.sortState === 2 ? 0 : item.sortState+1})} className="sort-icon"/>
                                    }
                                    {
                                        (item.sortState === 1  && i !== 0) &&
                                        <BiSolidUpArrow onClick={() => handleSortChange({id: item.id, sortState: item.sortState === 2 ? 0 : item.sortState+1})} className="sort-icon"/>
                                    }
                                    {
                                        (item.sortState === 2  && i !== 0) &&
                                        <BiSolidDownArrow onClick={() => handleSortChange({id: item.id, sortState: item.sortState === 2 ? 0 : item.sortState+1})} className="sort-icon"/>
                                    }
                                </div>
                            </th>
                        ))
                    }
                </tr>
            </thead>
            <tbody>
                {
                    cityListOption?.map((item) => (
                        <tr>
                            <td>{cityToCityIndex.city}</td>
                            <td>{item.city}</td>
                            <td><input type="text" value={item.index} onChange={(e) => handleChange({key: "index", value: e.target.value, id: item.id })}/></td>
                            <td><input type="text" value={item.km} onChange={(e) => handleChange({key: "km", value: e.target.value, id: item.id })}/></td>
                        </tr>
                    ))
                }
             </tbody>
        </table>
        <div className="bottom-container">
            <Btn handleClick={handleSubmit} bgColor="#E85446" color="#fff" width={"260px"}>Güncelle</Btn>
        </div>
    </Container>
  )
}

export default NakliyeCityToCityIndex